const wards = [
    15,
    23,
    27,
    31,
    33
]

export default wards;